import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import {
  GoogleMaps,
  GoogleMap,
  GoogleMapsEvent,
  GoogleMapOptions,
  CameraPosition,
  MarkerOptions,
  Marker
} from '@ionic-native/google-maps';
import { CallNumber } from '@ionic-native/call-number';
import { EmailComposer } from '@ionic-native/email-composer';
@Component({
  selector: 'page-contact',
  templateUrl: 'contact.html'
})
export class ContactPage {

  constructor(public navCtrl: NavController,private googleMaps: GoogleMaps,public callNumber: CallNumber,private emailComposer: EmailComposer, private inAppBrowser:InAppBrowser) {
    
  }
  call(number: string) 
  {
    console.log("call called");
    if(this.callNumber.isCallSupported)
    {
      console.log("call is supported");
      this.callNumber.callNumber(number, true)
      .then(() => console.log('Dialer Launched!'))
      .catch(() => console.log('Error launching dialer'));
    }
   
  }
  mail(){
    console.log("mail called");
    this.emailComposer.isAvailable().then((available: boolean) =>{
      if(available) {
        console.log("mailcomposer available");
        
      }
     });
     let email = {
      to: 'info@hotelsalden.nl',
      subject: 'Vraag via de mobiele applicatie',
      body: '',
      isHtml: true
    };
    console.log("composer open called");
    // Send a text message using default options
    this.emailComposer.open(email);
     
  } 
  launch(url) {
    this.inAppBrowser.create(url, "_system", "location=true");
  }
   ionViewDidLoad() {
    this.loadNativeMap('50.854619','5.871284','map');
   }
  loadNativeMap(long: string, lat: string, name: string) {
    console.log('Map is building!');
let map: GoogleMap;
    let mapOptions: GoogleMapOptions = {
      camera: {
        target: {
          lat: lat,
          lng: long
        },
        zoom: 18,
        tilt: 30
      }
    };

    map = GoogleMaps.create(name, mapOptions);

    // Wait the MAP_READY before using any methods.
    map.one(GoogleMapsEvent.MAP_READY)
      .then(() => {
        console.log('Map is loading');

        // Now you can use all methods safely.
        map.addMarker({
          title: 'Plaats',
          icon: 'blue',
          animation: 'DROP',
          position: {
            lat: Number(lat),
            lng: Number(long)
          }
        });
          // .then(marker => {
          //   marker.on(GoogleMapsEvent.MARKER_CLICK)
          //     .subscribe(() => {
          //       alert('clicked');
          //     });
          // });
          map.setDiv(name);
      })
    .catch(reject => {
      console.log(reject);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/contact/contact.ts